
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 18","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.151 17.597l-7.8-7.8a1.2 1.2 0 010-1.697l1.697-1.697a1.2 1.2 0 011.697 0L9 11.657 20.254.403a1.2 1.2 0 011.697 0L23.648 2.1a1.2 1.2 0 010 1.697l-13.8 13.8a1.2 1.2 0 01-1.697 0z"}})])
          )
        }
      }
    